import { render, staticRenderFns } from "./certificateAuditList-final.vue?vue&type=template&id=3260c133&scoped=true&"
import script from "./certificateAuditList-final.vue?vue&type=script&lang=js&"
export * from "./certificateAuditList-final.vue?vue&type=script&lang=js&"
import style0 from "./certificateAuditList-final.vue?vue&type=style&index=0&id=3260c133&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3260c133",
  null
  
)

export default component.exports